const availableParts = [
  require("../../../provision/parts/ant/ant.json"),
  require("../../../provision/parts/anthill/anthill.json"),
  require("../../../provision/parts/apron/apron.json"),
  require("../../../provision/parts/bam/bam.json"),
  require("../../../provision/parts/basket/basket.json"),
  require("../../../provision/parts/beetle/beetle.json"),
  require("../../../provision/parts/box/box.json"),
  require("../../../provision/parts/boulder/boulder.json"),
  require("../../../provision/parts/cave walls/cave walls.json"),
  require("../../../provision/parts/chichi/chichi.json"),
  require("../../../provision/parts/coconut/coconut.json"),
  require("../../../provision/parts/crystal/crystal.json"),
  require("../../../provision/parts/door/door.json"),
  require("../../../provision/parts/droplet/droplet.json"),
  require("../../../provision/parts/flashlight/flashlight.json"),
  require("../../../provision/parts/flower/flower.json"),
  require("../../../provision/parts/gem/gem.json"),
  require("../../../provision/parts/forest floor/forest floor.json"),
  require("../../../provision/parts/hat/hat.json"),
  require("../../../provision/parts/key/key.json"),
  require("../../../provision/parts/lava/lava.json"),
  require("../../../provision/parts/leaf/leaf.json"),
  require("../../../provision/parts/lock/lock.json"),
  require("../../../provision/parts/mango/mango.json"),
  require("../../../provision/parts/melon/melon.json"),
  require("../../../provision/parts/muff/muff.json"),
  require("../../../provision/parts/mushroom/mushroom.json"),
  require("../../../provision/parts/palm/palm.json"),
  require("../../../provision/parts/papaya/papaya.json"),
  require("../../../provision/parts/pot/pot.json"),
  require("../../../provision/parts/rock/rock.json"),
  require("../../../provision/parts/shedding/shedding.json"),
  require("../../../provision/parts/spores/spores.json"),
  require("../../../provision/parts/stick/stick.json"),
  require("../../../provision/parts/stone-floor/stone-floor.json"),
  require("../../../provision/parts/torch/torch.json"),
  require("../../../provision/parts/trunk/trunk.json"),
  require("../../../provision/parts/water/water.json"),
  require("../../../provision/parts/zuzo/zuzo.json"),
];

module.exports = availableParts;
